import { TrackingEventName } from 'services/tracking/constants';
import { CampaignFilterIds } from '../constants/filters';

export const handleFilterTracking = ({
  filterId,
  track
}: {
  filterId: string;
  track: (eventName: string, properties?: Record<string, any>) => void;
}) => {
  if (filterId === CampaignFilterIds.status) {
    track(TrackingEventName.CampaignsListStatusFilter);
  }

  if (filterId === CampaignFilterIds.needsReview) {
    track(TrackingEventName.CampaignsListNeedsReviewFilter);
  }
};
